import Operation from './Operation.js';

class DeleteCompoundEvent extends Operation {
    constructor(mix, event, subEvent) {
        super(mix, event.getType());

        this.event = event;
        this.subEvent = subEvent;
    }

    execute() {
        // first find the event
        let step = this.subEvent.step;
        let duration = this.subEvent.duration;
        let index = this.event.deleteSubEvent(this.subEvent);

        if (index < 0) {
            return;
        }

        if (this.event.isEmpty()) {
            index = this.mixByType.events.indexOf(this.event);
            this.mixByType.events.splice(index, 1);
            this.mixByType.calculateDurations();
            this.mix.updateAllTypeRedux();
            return;
        }

        // then move all the proceeding sub events events to the beginning
        // of the deleted event
        let subEvents = this.event.subEvents;
        for (let i in subEvents) {
            if (subEvents[i].step > step) {
                subEvents[i].step -= duration;
                break;
            }

        }

        // set the sub events to this newly spliced list
        this.mix.restart();

        this.event.calculateDurations();
        this.mixByType.calculateDurations();
        this.mix.updateAllTypeRedux();
    }
}

export default DeleteCompoundEvent;
 
